const capitalizeString = (text:string) => {
  const firstLetter = text.charAt(0).toUpperCase();
  const result = text.replace(text.charAt(0), firstLetter);
  
  return result;
}

export default capitalizeString;